// App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/home";
import RealFake from "./pages/quiz/RealFake";
import Scenario from "./pages/quiz/Scenario";
import BackgroundInfo from "./pages/BackgroundInfo";
import InfoFromBackground from "./pages/InfoFromBackground";
import ClaimPage from "./pages/ClaimPage";
import ParliamentChamberMap from "./pages/ParliamentChamberMap";
import MatchPage from "./pages/MatchPage";
import PolicySwipe from "./pages/PolicySwipe";
import PoliticalMatchIntro from "./pages/PoliticalMatchIntro";
import PolicyAreaSelection from "./pages/PolicyAreaSelection";
import MPProfile from "./pages/MPProfile";
import TrendingTopics from "./pages/TrendingTopics";
import Navbar from "./components/Navbar";
import Challenge from "./pages/quiz/Challenge";
import PasswordPage from "./pages/PasswordPage";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/password" element={<PasswordPage />} />

        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <>
                <Navbar />
                <div style={{ paddingTop: "70px" }}></div>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/ask" element={<ClaimPage />} />
                  <Route
                    path="/parliament-map"
                    element={<ParliamentChamberMap />}
                  />
                  <Route path="/challenge" element={<Challenge />} />
                  <Route path="/info" element={<BackgroundInfo />} />
                  <Route path="/topics" element={<TrendingTopics />} />
                  <Route path="/quiz" element={<RealFake />} />
                  <Route path="/scenario" element={<Scenario />} />
                  <Route path="/backgroundinfo" element={<BackgroundInfo />} />
                  <Route
                    path="/inforfrombackground"
                    element={<InfoFromBackground />}
                  />
                  <Route
                    path="/policy-swipe"
                    element={<PoliticalMatchIntro />}
                  />
                  <Route
                    path="/policy-areas"
                    element={<PolicyAreaSelection />}
                  />
                  <Route path="/policy-swipe/swipe" element={<PolicySwipe />} />
                  <Route path="/policy-swipe/matches" element={<MatchPage />} />
                  <Route path="/mp/:id" element={<MPProfile />} />
                </Routes>
              </>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
